export const ADD_ITEM = 'ADD_ITEM'
export const DECREASE_ITEM = 'DECREASE_ITEM'
export const REMOVE_ITEM_FROM_CART = 'REMOVE_ITEM_FROM_CART'